import {
  BASE_URL
} from '../../../util/constants/endpoints';

import {subfolder, moversFolder, checkoutFolder, accountFolder} from '../../../util/constants/directory';

export const navigationSteps = {
  myPlan: {
    MYPLAN: 'myplan',
    SPEED: 'myPlanSpeed',
    OFFERS: 'myPlanOffers',
    OFFERS_FILTER: 'myPlanOffersFilter',
    CHANNELS: 'myPlanChannels',
    ADDON_CHANNEL: 'myPlanAddOnChannel',
    ADDON_EQUIPMENT: 'myPlanAddOnEquipment',
    ADDON_MANAGE_STREAMING_VIDEO: 'myPlanAddOnStreamingVideo',
    UPSELL_STREAMING_VIDEO: 'myPlanUpsellStreamingVideo',
    CANCEL: 'myPlanCancel',
    REVIEW: 'myPlanReview',
    CONFIRMATION: 'myPlanConfirmation',
    OMNI_LANDING: 'myPlanOmniLanding',
    CONTACTUS: 'myPlanContactUs',
    MESSAGE: 'myPlanMessage',
    ERROR: 'myPlanError'
  },
  movers: {
    LOCALIZATION: 'moversLocalization',
    UNSERVICEABLE: 'moversUnserviceable',
    CANCEL: 'moversCancel',
    SPECIALIST: 'moversSpecialist',
    INSTALL: 'moversInstall',
    REVIEW: 'moversReview',
    CONFIRMATION: 'moversConfirmation',
    CONTACTUS: 'moversContactUs',
    CANCELLATION_CONTACTUS: 'moversCancellationContactUs',
    ERROR: 'moversError',
    CANCELLATION_ERROR: 'moversCancellationError'
  },
  quickCheckout: {
    CHECKOUT: 'checkout',
    REVIEW: 'review',
    CONFIRMATION: 'confirmation',
    REDIRECT: 'quickCheckoutRedirect',
    CONTACTUS: 'quickCheckoutContactUs',
    ERROR: 'checkoutError'
  },
  account: {
    MULTIPLE_ADDRESS: 'accountMultipleAddress'
  },
  omni: {
    OMNI_SALES: 'omniSales'
  }
};

export const navigationRoutes = {
  [navigationSteps.omni.OMNI_SALES]: {
    key: navigationSteps.omni.OMNI_SALES,
    path: `/omniSales`,
    name: 'OmniSales',
    endpoints : {
      omniLocalize : () => ({
        url: `http://services.stg.xfinity.com/OfferInquiries/api/localization/localize`,
        method: 'POST'
      }),
      getSuggestions : (search) => ({
        url: `https://www.stg.xfinity.com/learn/api/neptune/address-search/suggestions?search=${search}`,
        method: 'GET'
      }),
      tentantDecodeToken: () => ({
        url: `https://services.stg.xfinity.com/Tenant/api/tenant/decodetoken`,
        method: 'POST'
      }),
      tentantEncodeToken: () => ({
        url: `https://services.stg.xfinity.com/Tenant/api/tenant/create-token`,
        method: 'POST'
      }),
      getReleaseNotes: () => ({
        url: `//omni-feedback.aws-origin.xfinity.com/api/category/1/release-notes`,
        method: 'GET'
      }),
      getFeatures: () => ({
        url: `//omni-feedback.aws-origin.xfinity.com/api/category/2/feature-requests`,
        method: 'GET'
      }),
      getIssues: () => ({
        url: `//omni-feedback.aws-origin.xfinity.com/api/category/4/report-an-issue`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.myPlan.MYPLAN]: {
    key: navigationSteps.myPlan.MYPLAN,
    path: `${subfolder}/myplan`,
    name: 'MyPlan',
    endpoints : {
      validateAuth : () => ({
        url: `${BASE_URL}${subfolder}/api/authentication`,
        method: 'GET'
      }),
      loadCustomer : () => ({
        url: `${BASE_URL}${subfolder}/api/customer`,
        method: 'GET'
      }),
      loadPlan : () => ({
        url: `${BASE_URL}${subfolder}/api/customer/plan`,
        method: 'GET'
      }),
      loadEquipment : () => ({
        url: `${BASE_URL}${subfolder}/api/customer/equipments`,
        method: 'GET'
      }),
      getContext : (validatePlanAvailable = 'false') => ({
        url: `${BASE_URL}${subfolder}/api/customer/consumerContext?validatePlanAvailable=${validatePlanAvailable}`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.myPlan.REVIEW]: {
    key: navigationSteps.myPlan.REVIEW,
    path: `${subfolder}/review`,
    name: 'Review',
    endpoints : {
      reviewCart : () => ({
        url: `${BASE_URL}${subfolder}/api/carts/reviewcart`,
        method: 'POST'
      }),
      submitOrder : () => ({
        url: `${BASE_URL}${subfolder}/api/order/submitorder`,
        method: 'POST'
      })
    },
    apiNames: []
  },
  [navigationSteps.myPlan.CONFIRMATION]: {
    key: navigationSteps.myPlan.CONFIRMATION,
    path: `${subfolder}/confirmation`,
    name: 'Confirmation',
    endpoints : {
      getConfirmation : () => ({
        url: `${BASE_URL}${subfolder}/api/confirm/details`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.myPlan.CHANNELS]: {
    key: navigationSteps.myPlan.CHANNELS,
    path: `${subfolder}/channels`,
    name: 'Customize Channels',
    endpoints : {
      loadOfferByChannels : () => ({
        url: `${BASE_URL}${subfolder}/api/offer/channelgroups`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.myPlan.ADDON_CHANNEL]: {
    key: navigationSteps.myPlan.ADDON_CHANNEL,
    path: `${subfolder}/addon/channel`,
    name: 'Customize channels',
    endpoints : {
      checkEligibility : (buyflowConsumerType) => ({
        url: `${BASE_URL}${subfolder}/api/customers/eligibilities/${buyflowConsumerType}`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.myPlan.ADDON_EQUIPMENT]: {
    key: navigationSteps.myPlan.ADDON_EQUIPMENT,
    path: `${subfolder}/addon/equipment`,
    name: 'Customize equipment'
  },
  [navigationSteps.myPlan.ADDON_MANAGE_STREAMING_VIDEO]: {
    key: navigationSteps.myPlan.ADDON_MANAGE_STREAMING_VIDEO,
    path: `${subfolder}/addon/manage-streaming-video`,
    name: 'Manage Streaming Video'
  },
  [navigationSteps.myPlan.UPSELL_STREAMING_VIDEO]: {
    key: navigationSteps.myPlan.UPSELL_STREAMING_VIDEO,
    path: `${subfolder}/addon/streaming-video`,
    name: 'Streaming Video',
    endpoints : {
      addToCart : () => ({
        url: `${BASE_URL}${subfolder}/api/carts/offers/streamingVideo`,
        method: 'POST'
      })
    }
  },
  [navigationSteps.myPlan.CANCEL]: {
    key: navigationSteps.myPlan.CANCEL,
    path: `${subfolder}/cancel`,
    name: 'Cancel',
    endpoints : {
      confirmCart : () => ({
        url: `${BASE_URL}${subfolder}/api/carts/confirmcart`,
        method: 'POST'
      })
    }
  },
  [navigationSteps.myPlan.OMNI_LANDING]: {
    key: navigationSteps.myPlan.OMNI_LANDING,
    path: `${subfolder}/omni-landing`,
    name: 'Omni Landing Page',
    endpoints : {
      getPrerequisites : () => ({
        url: `${BASE_URL}${subfolder}/api/omni/prerequisites`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.myPlan.SPEED]: {
    key: navigationSteps.myPlan.SPEED,
    path: `${subfolder}/internet-speed`,
    name: 'Customize Internet Speed',
    endpoints : {
      loadOfferBySpeed : () => ({
        url: `${BASE_URL}${subfolder}/api/offer/speedgroups`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.myPlan.OFFERS]: {
    key: navigationSteps.myPlan.OFFERS,
    path: `${subfolder}/offers`,
    name: 'Customize Offers',
    endpoints : {
      loadContent : (dataString) => ({
        url: `${BASE_URL}${subfolder}/api/offer/byfilter?${dataString}`,
        method: 'GET'
      }),
      addOfferToCart : () => ({
        url: `${BASE_URL}${subfolder}/api/cart/offeradd`,
        method: 'POST'
      }),
      addDefaultOfferToCart : () => ({
        url: `${BASE_URL}${subfolder}/api/carts/offers/default`,
        method: 'POST'
      })
    }
  },
  [navigationSteps.myPlan.OFFERS_FILTER]: {
    key: navigationSteps.myPlan.OFFERS_FILTER,
    path: `${subfolder}/offersFilter`,
    name: 'Customize Offers'
  },
  [navigationSteps.myPlan.CONTACTUS]: {
    key: navigationSteps.myPlan.CONTACTUS,
    path: `${subfolder}/contact-us`,
    name: 'Contact Us',
    endpoints : {
      userInteraction : () => ({
        url: `${BASE_URL}${subfolder}/api/log/userinteraction`,
        method: 'POST'
      })
    }
  },
  [navigationSteps.myPlan.MESSAGE]: {
    key: navigationSteps.myPlan.MESSAGE,
    path: `${subfolder}/message`,
    name: 'Message',
  },
  [navigationSteps.myPlan.ERROR]: {
    key: navigationSteps.myPlan.ERROR,
    path: `${subfolder}/error`,
    name: 'Error',
    endpoints : {
      logErrors : () => ({
        url: `${BASE_URL}${subfolder}/api/log/apperror`,
        method: 'POST'
      })
    }
  },
  [navigationSteps.movers.LOCALIZATION]: {
    key: navigationSteps.movers.LOCALIZATION,
    path: `${subfolder}/${moversFolder}/localization`,
    name: 'Localization',
    endpoints : {
      moveCustomer : () => ({
        url: `${BASE_URL}${subfolder}/api/customer/move/moveto`,
        method: 'POST'
      }),
      getSuggestions : (search) => ({
        url: `${BASE_URL}${subfolder}/api/move/address-search?search=${search}`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.movers.UNSERVICEABLE]: {
    key: navigationSteps.movers.UNSERVICEABLE,
    path: `${subfolder}/${moversFolder}/unserviceable`,
    name: 'Unserviceable',
    apiNames: [],
    endpoints : {
      getBingData : encodedAddressSearch => ({
        url: `//dev.virtualearth.net/REST/v1/Locations?query=${encodedAddressSearch}&maxResults=1&key=AkMwtnd4qXsRuh77BytvNEuuVfOUuPdyUuaowJeExSCBKk-OBj8YlYTIqCJW2Gom`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.movers.CANCEL]: {
    key: navigationSteps.movers.CANCEL,
    path: `${subfolder}/${moversFolder}/cancel`,
    name: 'Cancel',
    endpoints : {
      disconnectCustomer : () => ({
        url: `${BASE_URL}${subfolder}/api/customer/move/disconnect`,
        method: 'POST'
      })
    },
    apiNames: []
  },
  [navigationSteps.movers.SPECIALIST]: {
    key: navigationSteps.movers.SPECIALIST,
    path: `${subfolder}/${moversFolder}/specialist`,
    name: 'Specialist',
    endpoints : {
      submitOrder : () => ({
        url: `${BASE_URL}${subfolder}/api/checkout/submitorder`,
        method: 'POST'
      })
    },
    apiNames: []
  },
  [navigationSteps.movers.INSTALL]: {
    key: navigationSteps.movers.INSTALL,
    path: `${subfolder}/${moversFolder}/install`,
    name: 'Install',
    endpoints : {
      loadInstall : (retrieveTimeSlots = false) => ({
        url: `${BASE_URL}${subfolder}/api/cart/installation/${retrieveTimeSlots}`,
        method: 'GET'
      }),
      confirmSik : () => ({
        url: `${BASE_URL}${subfolder}/api/cart/installation-sik`,
        method: 'POST'
      }),
      confirmPro : () => ({
        url: `${BASE_URL}${subfolder}/api/cart/installation-pro`,
        method: 'POST'
      })
    },
    apiNames: []
  },
  [navigationSteps.movers.REVIEW]: {
    key: navigationSteps.movers.REVIEW,
    path: `${subfolder}/${moversFolder}/review`,
    name: 'Review',
    endpoints : {
      loadReview : () => ({
        url: `${BASE_URL}${subfolder}/api/move/review`,
        method: 'GET'
      }),
      submitOrder : () => ({
        url: `${BASE_URL}${subfolder}/api/checkout/submitorder`,
        method: 'POST'
      })
    },
    apiNames: []
  },
  [navigationSteps.movers.CONFIRMATION]: {
    key: navigationSteps.movers.CONFIRMATION,
    path: `${subfolder}/${moversFolder}/confirmation`,
    name: 'Confirmation',
    endpoints : {
      loadConfirmation : () => ({
        url: `${BASE_URL}${subfolder}/api/move/confirm`,
        method: 'GET'
      })
    },
    apiNames: []
  },
  [navigationSteps.movers.CONTACTUS]: {
    key: navigationSteps.movers.CONTACTUS,
    path: `${subfolder}/${moversFolder}/contact-us`,
    name: 'Contact Us',
    endpoints : {
      userInteraction : () => ({
        url: `${BASE_URL}${subfolder}/api/log/userinteraction`,
        method: 'POST'
      })
    }
  },
  [navigationSteps.movers.CANCELLATION_CONTACTUS]: {
    key: navigationSteps.movers.CANCELLATION_CONTACTUS,
    path: `${subfolder}/${moversFolder}/cancel/contact-us`,
    name: 'Contact Us',
    endpoints : {
      userInteraction : () => ({
        url: `${BASE_URL}${subfolder}/api/log/userinteraction`,
        method: 'POST'
      })
    }
  },
  [navigationSteps.movers.ERROR]: {
    key: navigationSteps.movers.ERROR,
    path: `${subfolder}/${moversFolder}/error`,
    name: 'Error',
    apiNames: []
  },
  [navigationSteps.movers.CANCELLATION_ERROR]: {
    key: navigationSteps.movers.CANCELLATION_ERROR,
    path: `${subfolder}/${moversFolder}/cancel/error`,
    name: 'Error',
    apiNames: []
  },
  [navigationSteps.quickCheckout.CHECKOUT]: {
    key: navigationSteps.quickCheckout.CHECKOUT,
    path: `${subfolder}/${checkoutFolder}`,
    name: 'Checkout',
    endpoints : {
      validateProductMapping : tveGoChannelUID => ({
        url: `${BASE_URL}${subfolder}/api/checkout/validateproductmapping?tveGoChannelUID=${tveGoChannelUID}`,
        method: 'GET'
      }),
      addDefaultOffer : () => ({
        url: `${BASE_URL}${subfolder}/api/cart/defaultofferadd`,
        method: 'POST'
      }),
      validateCustomerLobAndProduct : shoppingElementId => ({
        url: `${BASE_URL}${subfolder}/api/checkout/validatecustomerlobandproduct?shoppingElementId=${shoppingElementId}`,
        method: 'GET'
      }),
      validateProductForQuickcheckout : payload => ({
        url: `${BASE_URL}${subfolder}/api/checkout/validateproductforquickcheckout?productName=${payload.productName}&checkoutType=${payload.checkoutType}`,
        method: 'GET'
      }),
      configureProductToCart : productId => ({
        url: `${BASE_URL}${subfolder}/api/checkout/configureproducttocart?productId=${productId}`,
        method: 'POST'
      }),
      analytics: () => ({
        url: `${BASE_URL}${subfolder}/api/analytics/quickcheckout?message=`,
        method: 'GET'
      })
    },
    apiNames: []
  },
  [navigationSteps.quickCheckout.REVIEW]: {
    key: navigationSteps.quickCheckout.REVIEW,
    path: `${subfolder}/${checkoutFolder}/review`,
    name: 'Review',
    endpoints: {
      reviewCart : () => ({
        url: `${BASE_URL}${subfolder}/api/checkout/review`,
        method: 'GET'
      }),
      submitOrder : () => ({
        url: `${BASE_URL}${subfolder}/api/checkout/submitorder`,
        method: 'POST'
      })
    },
    apiNames: []
  },
  [navigationSteps.quickCheckout.CONFIRMATION]: {
    key: navigationSteps.quickCheckout.CONFIRMATION,
    path: `${subfolder}/${checkoutFolder}/confirmation`,
    name: 'Confirmation',
    endpoints : {
      getConfirmation : () => ({
        url: `${BASE_URL}${subfolder}/api/confirm/getinfo?confirmationRequest.populateAnalyticsData=true&confirmationRequest.isQuickCheckOut=true`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.quickCheckout.REDIRECT]: {
    key: navigationSteps.quickCheckout.REDIRECT,
    path: `${subfolder}/${checkoutFolder}/redirect`,
    name: 'Redirect'
  },
  [navigationSteps.quickCheckout.CONTACTUS]: {
    key: navigationSteps.quickCheckout.CONTACTUS,
    path: `${subfolder}/${checkoutFolder}/contact-us`,
    name: 'Contact Us',
    endpoints : {
      userInteraction : () => ({
        url: `${BASE_URL}${subfolder}/api/log/userinteraction`,
        method: 'POST'
      })
    }
  },
  [navigationSteps.quickCheckout.ERROR]: {
    key: navigationSteps.quickCheckout.ERROR,
    path: `${subfolder}/${checkoutFolder}/error`,
    name: 'Sorry',
    apiNames: []
  },
  [navigationSteps.account.ACCOUNT]: {
    key: navigationSteps.account.ACCOUNT,
    path: `${subfolder}/${accountFolder}`,
    name: 'Account',
    endpoints : {
      getRedirect : () => ({
        url: `${BASE_URL}${subfolder}/api/customer/accounts`,
        method: 'GET'
      })
    }
  },
  [navigationSteps.account.MULTIPLE_ADDRESS]: {
    key: navigationSteps.account.MULTIPLE_ADDRESS,
    path: `${subfolder}/${accountFolder}/multiple-address`,
    name: 'Multiple Address',
    endpoints : {
      getAddresses : () => ({
        url: `${BASE_URL}${subfolder}/api/customer/accounts/details`,
        method: 'GET'
      }),
      setAddress : accountNumber => ({
        url: `${BASE_URL}${subfolder}/api/customer/${accountNumber}`,
        method: 'POST'
      })
    }
  }
};

export const buyFlowUrls = {
  CUSTOMIZE: '/buy/customize'
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/navigation/navigationHelpers.js
 **/